document.addEventListener("DOMContentLoaded", function () {
  const createOdometer = (el, value, format) => {
    const odometer = new Odometer({
      el: el,
      value: 0,
      format: "(,ddd)",
    });

    let hasRun = false;
    const suffixEl = el.parentElement.querySelector(".stat-suffix");

    const options = { threshold: 0.6 };

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasRun) {
          let finalValue = value;

          switch (format) {
            case "plus":
              odometer.update(value);
              if (suffixEl) suffixEl.textContent = "+";
              break;

            case "percent":
              odometer.update(value);
              if (suffixEl) suffixEl.textContent = "%";
              break;

            case "short":
              if (value >= 1000000) {
                finalValue = (value / 1000000).toFixed(1);
                odometer.update(finalValue);
                if (suffixEl) suffixEl.textContent = "M";
              } else if (value >= 1000) {
                finalValue = (value / 1000).toFixed(1);
                odometer.update(finalValue);
                if (suffixEl) suffixEl.textContent = "K";
              } else {
                odometer.update(value);
              }
              break;

            case "raw":
            default:
              odometer.update(value);
              break;
          }

          hasRun = true;
          observer.unobserve(el);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(el);
  };

  // lấy tất cả các số
  const statNumbers = document.querySelectorAll(".stat-number.odometer");
  statNumbers.forEach((el) => {
    const value = parseInt(el.dataset.target, 10) || 0;
    const format = el.dataset.format || "raw";
    createOdometer(el, value, format);
  });
});
